import { BookingResourceTypeEnum } from '@repo/common/interfaces';
import { VpIconName } from '@vtmn-play/react';

export const resourceIcons: Record<BookingResourceTypeEnum, VpIconName> = {
  [BookingResourceTypeEnum.PERSON]: 'user',
  [BookingResourceTypeEnum.RESOURCE]: 'function-tiles',
};
